import { render } from "./AposContextMenuItem.vue?vue&type=template&id=5bd67773&scoped=true"
import script from "./AposContextMenuItem.vue?vue&type=script&lang=js"
export * from "./AposContextMenuItem.vue?vue&type=script&lang=js"

import "./AposContextMenuItem.vue?vue&type=style&index=0&id=5bd67773&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd67773"],['__file',"ui/ui/apos/components/AposContextMenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5bd67773"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bd67773', __exports__)) {
    api.reload('5bd67773', __exports__)
  }
  
  module.hot.accept("./AposContextMenuItem.vue?vue&type=template&id=5bd67773&scoped=true", () => {
    api.rerender('5bd67773', render)
  })

}


export default __exports__